import React, { useEffect, useContext } from "react";
import { useSelector } from "react-redux";

import { DF_CO0008Context } from "../context";
import config from "../../../../config";

function GridBody() {
  const { parseParams } = useContext(DF_CO0008Context);

  const ID_Arquivo = parseParams.get("ID_Arquivo");

  const { tokenAcesso } = useSelector((state) => ({
    tokenAcesso: state.login.user?.resultset_1?.[0]?.Token_Acesso,
  }));

  useEffect(() => {
    if (!ID_Arquivo || !tokenAcesso) {
      return;
    }

    try {
      const baseUrl = config.URL_BIZIN;

      const url = `${baseUrl}/EDI_DownloadFileV2.aspx?ID_Arquivo=${ID_Arquivo}&token=${tokenAcesso}`;

      window.open(url, "_self");
    } catch (error) {
      console.log("erro ao realizar download:", error);
    }
  }, [ID_Arquivo, tokenAcesso]);

  return null;
}

export default GridBody;